/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_EmployeeTypeDto } from '../models/PagedResultDto_EmployeeTypeDto';
import type { Wealthlane_CustomerService_Dtos_EmployeeType_CreateEmployeeTypeDto } from '../models/Wealthlane_CustomerService_Dtos_EmployeeType_CreateEmployeeTypeDto';
import type { Wealthlane_CustomerService_Dtos_EmployeeType_EmployeeTypeDto } from '../models/Wealthlane_CustomerService_Dtos_EmployeeType_EmployeeTypeDto';
import type { Wealthlane_CustomerService_Dtos_EmployeeType_UpdateEmployeeTypeDto } from '../models/Wealthlane_CustomerService_Dtos_EmployeeType_UpdateEmployeeTypeDto';
import type { Wealthlane_CustomerService_Dtos_Response_ResponseDto } from '../models/Wealthlane_CustomerService_Dtos_Response_ResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class EmployeeTypeService {

    /**
     * @param requestBody
     * @returns Wealthlane_CustomerService_Dtos_EmployeeType_EmployeeTypeDto OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppEmployeeTypeEmployeeType(
        requestBody?: Wealthlane_CustomerService_Dtos_EmployeeType_CreateEmployeeTypeDto,
    ): CancelablePromise<Wealthlane_CustomerService_Dtos_EmployeeType_EmployeeTypeDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/employee-type/employee-type',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns Wealthlane_CustomerService_Dtos_EmployeeType_UpdateEmployeeTypeDto OK
     * @throws ApiError
     */
    public static putApiCustomerApiAppEmployeeTypeEmployeeType(
        requestBody?: Wealthlane_CustomerService_Dtos_EmployeeType_UpdateEmployeeTypeDto,
    ): CancelablePromise<Wealthlane_CustomerService_Dtos_EmployeeType_UpdateEmployeeTypeDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/customer/api/app/employee-type/employee-type',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param employeeTypeId
     * @returns Wealthlane_CustomerService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static deleteApiCustomerApiAppEmployeeTypeEmployeeType(
        employeeTypeId: string,
    ): CancelablePromise<Wealthlane_CustomerService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/customer/api/app/employee-type/employee-type/{employeeTypeId}',
            path: {
                'employeeTypeId': employeeTypeId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param employeeTypeId
     * @returns Wealthlane_CustomerService_Dtos_EmployeeType_EmployeeTypeDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppEmployeeTypeEmployeeType(
        employeeTypeId: string,
    ): CancelablePromise<Wealthlane_CustomerService_Dtos_EmployeeType_EmployeeTypeDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/employee-type/employee-type/{employeeTypeId}',
            path: {
                'employeeTypeId': employeeTypeId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_CustomerService_Dtos_EmployeeType_EmployeeTypeDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppEmployeeTypeEmployeeTypes(): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_EmployeeType_EmployeeTypeDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/employee-type/employee-types',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param isTaxEnabled
     * @param filter
     * @param sorting
     * @param skipCount
     * @param maxResultCount
     * @returns PagedResultDto_EmployeeTypeDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppEmployeeTypeEmployeeTypesList(
        isTaxEnabled?: boolean,
        filter?: string,
        sorting?: string,
        skipCount?: number,
        maxResultCount?: number,
    ): CancelablePromise<PagedResultDto_EmployeeTypeDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/employee-type/employee-types-list',
            query: {
                'IsTaxEnabled': isTaxEnabled,
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
